import 'rc-select/assets/index.css';
import 'rc-checkbox/assets/index.css';

import React, { Component } from 'react';
import Checkbox from 'rc-checkbox';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';
import sortBy from 'lodash/sortBy';
import Select from 'components/TeacherSelect';
import { connect } from 'react-redux';
import { updateTeacherListing } from 'actions/Teacher/listingActions';

import Footer from '../../Footer';

import './style.css';

const initialState = listing => ({
  service: listing.service.id,
  status: listing.status,
  ageLevels: listing.ageLevels.map(item => item.id),
  specializations: listing.specializations.map(item => item.id),
  errors: {}
});

class TeacherListingDetails extends Component {
  constructor(props) {
    super(props);

    this.state = initialState(props.listing);
  }

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
      errors: omit(this.state.errors, field)
    });
  }

  handleAgeLevelChange = (value) => {
    const { ageLevels } = this.state;

    this.setState({
      ageLevels: ageLevels.includes(value) ?
        ageLevels.filter(item => item !== value) :
        [...ageLevels, value],
      errors: omit(this.state.errors, 'ageLevels')
    });
  }

  handleSpecializationChange = (selectedIndex, value) => {
    const { specializations } = this.state;

    this.setState({
      specializations: specializations.map((item, index) => (index === selectedIndex ? value : item)),
      errors: omit(this.state.errors, 'specializations')
    });
  }

  handleAddSpecialization = () => {
    this.setState({
      specializations: [...this.state.specializations, '']
    });
  }

  handleRemoveSpecialization = (selectedIndex) => {
    this.setState({
      specializations: this.state.specializations.filter((item, index) => index !== selectedIndex)
    });
  }

  prepareListingData = () => {
    const { status, ageLevels, specializations } = this.state;
    const { listing } = this.props;

    const prevAgeLevels = listing.ageLevels.map(item => item.id);
    const prevSpecializations = listing.specializations.map(item => item.id);
    const filteredSpecializations = specializations.filter(item => item !== '');

    const data = {};
    if (!isEqual(sortBy(ageLevels), sortBy(prevAgeLevels))) {
      data.ageLevels = ageLevels;
    }
    if (!isEqual(sortBy(filteredSpecializations), sortBy(prevSpecializations))) {
      data.specializations = filteredSpecializations;
    }
    if (status !== listing.status) {
      data.status = status;
    }
    return data;
  }

  checkDataChanged = () => {
    const data = this.prepareListingData();

    return !isEmpty(data);
  }

  handleSave = () => {
    const data = this.prepareListingData();
    const { listing, updateTeacherListing: updateTeacherListingFn } = this.props;

    if (!isEmpty(data)) {
      updateTeacherListingFn(listing.id, data);
    }
  }

  handleCancel = () => {
    this.setState(initialState(this.props.listing));
  }

  render() {
    const {
      service, status, ageLevels, specializations
    } = this.state;
    const {
      services, allAgeLevels, allSpecializations, updateListingStatus
    } = this.props;
    const selectedService = services.find(item => item.id === service);
    if (!selectedService) {
      return null;
    }

    return (
      <div className="teacher-listing-details d-flex flex-column">
        <div className="teacher-listing-details__fields px-4 px-lg-5">
          <div className="teacher-listing-details__fields-inner">
            {/* <div className="my-5">
              <h6 className="mb-4">What do you want to teach?</h6>
              <Select
                name="service"
                options={services}
                value={service}
                onChange={this.handleChange}
              />
            </div> */}
            <div className="my-5">
              <h6 className="mb-1">Age level focus:</h6>
              <div className="row">
                {allAgeLevels.map((ageLevel, index) => (
                  <div key={index} className="col-12 col-sm-6 mt-3">
                    <label className="teacher-listing-details__checkbox m-0 btn-cursor">
                      <Checkbox
                        name={ageLevel.description}
                        checked={ageLevels.includes(ageLevel.id)}
                        onChange={() => this.handleAgeLevelChange(ageLevel.id)}
                      />
                      &nbsp;&nbsp; {ageLevel.description}
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <div className="my-5">
              <h6 className="mb-4">Specialization</h6>
              {specializations.map((spec, index) => (
                <div key={index} className="teacher-listing-details__spec mt-2">
                  <Select
                    name="specializations"
                    options={allSpecializations}
                    value={spec}
                    onChange={(field, value) => this.handleSpecializationChange(index, value)}
                    extendText={selectedService.description}
                  />
                  <div
                    className="teacher-listing-details__spec-close btn-cursor"
                    onClick={() => this.handleRemoveSpecialization(index)}
                  />
                </div>
              ))}
              <div
                className="teacher-listing-details__spec-add btn-cursor mt-3"
                onClick={this.handleAddSpecialization}
              >
                Add specialization
              </div>
            </div>
            <div className="my-5">
              <h6 className="mb-4">Status</h6>
              <Select
                name="status"
                options={['Online', 'Offline']}
                value={status}
                onChange={this.handleChange}
                size="small"
              />
            </div>
          </div>
        </div>
        <Footer
          onCancel={this.handleCancel}
          onSave={this.handleSave}
          disabled={!this.checkDataChanged()}
          isLoading={updateListingStatus === 'LOADING'}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    services: state.meta.services,
    allAgeLevels: state.meta.ageLevels,
    allSpecializations: state.meta.specializations,
    updateListingStatus: state.teacher.updateListingStatus
  };
}

export default connect(
  mapStateToProps,
  {
    updateTeacherListing
  }
)(TeacherListingDetails);



// WEBPACK FOOTER //
// ./src/pages/teacher/Schedule/Listings/Edit/Details/index.js